// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ErrorApiDefaultMessage } from "@vanmeter/XDL/constants";

const contentSearchServiceUri = "/api/vmi/search/content";

export interface SearchContentsModel {
    resultsCount?: number;
    pagination?: PaginationModel | null;
    searchResults?: {
        summary?: string;
        title?: string;
        url?: string;
    }[];
}

export interface SearchContentsParameter extends ApiParameter, HasPagingParameters {
    term: string;
}

export async function getSearchContents(
    parameters: SearchContentsParameter,
): Promise<ServiceResult<SearchContentsModel>> {
    try {
        const res = await get<SearchContentsModel>(contentSearchServiceUri, parameters);
        return {
            result: res,
            successful: true,
        };
    } catch (error) {
        return {
            successful: false,
            errorMessage: error?.errorJson?.message || error?.message || ErrorApiDefaultMessage,
        };
    }
}
